export const ResponseMessage = {
  serverError:
    "There is an error while getting the data. please try again later",
  methodImplementError: "Method not implemented.",
  InCompleteForm: "All fields are required",
  InvalidAmount: "Please enter a valid amount",
  InvalidNoOfAllowedUser: "Please enter a valid no. of allowed users",
};
